/**
 * Grid events
 */
(function ($) {

  var gridBreakpoints = {
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1900
  };

  var mediaQueries = {
    xs: window.matchMedia('(max-width: ' + (gridBreakpoints.sm - 1) + 'px)'),
    sm: window.matchMedia('(min-width: ' + (gridBreakpoints.sm) + 'px) and (max-width: ' + (gridBreakpoints.md - 1) + 'px)'),
    md: window.matchMedia('(min-width: ' + (gridBreakpoints.md) + 'px) and (max-width: ' + (gridBreakpoints.lg - 1) + 'px)'),
    lg: window.matchMedia('(min-width: ' + (gridBreakpoints.lg) + 'px) and (max-width: ' + (gridBreakpoints.xl - 1) + 'px)'),
    xl: window.matchMedia('(min-width: ' + (gridBreakpoints.xl) + 'px)')
  };

  // loop through queries
  for (var key in mediaQueries) {
    // call handler function explicitly at run time
    mediaQueryResponse(mediaQueries[key]);

    // call handler function whenever the media query is triggered
    mediaQueries[key].addListener(mediaQueryResponse);
  }

  function mediaQueryResponse(mediaQuery) {
    if (mediaQuery.matches) {
      for (var key in mediaQueries) {
        if (mediaQuery.media !== mediaQueries[key].media) {
          continue;
        }

        // Store current value as $(document).data('grid')
        $(document).data('grid', {'breakpoint': key, 'mediaQuery': mediaQuery.media});

        // Trigger event for listeners
        $(document).trigger('common.grid', {
            'breakpoint': key,
            'mediaQuery': mediaQuery.media
          }
        );
      }
    }
  }

})(window.jQuery);
